import SEO from '../components/SEO';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
import TestimonialsSection from '../components/TestimonialsSection';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TestimonialsPage = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${API}/testimonials`);
        setTestimonials(response.data);
      } catch {
        // Error handled silently
      }
    };
    fetchTestimonials();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Client Testimonials" description="Read what our clients say about SDORA Wellbeing mental health services in Pikesville, MD." path="/testimonials" />
      
      {/* Page Header */}
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Real stories from people who found hope and healing with our compassionate, evidence-based care.
          </p>
        </div>
      </div>

      <TestimonialsSection testimonials={testimonials} />
      <Footer />
    </div>
  );
};

export default TestimonialsPage;